// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1rsve","requiredAsterisk":"Info_requiredAsterisk__3Wj1d"};